import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Checkbox } from '../../../components/Checkbox';
import { Modal, ModalControls } from '../../../components/Modal';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { validateRDW, orbTransferOut } from '../actions';
import { Check, Times } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import { CompanyLabel } from '../../Companies/components/CompanyLabel';
import { vehicleSearch, fetchVehicle, setVehicleProperty } from '../../Vehicles/actions';
import { fetchInvoice } from '../../Invoices/actions';
import { fetchCompany, setCompanyProperty } from '../../Companies/actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_VEHICLES } from '../../Vehicles/constants';
import { REQUEST_INVOICE } from '../../Invoices/constants';
import { ORB_TRANSFER_OUT } from '../constants';

import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import styles from './ORBModal.module.css';

const Subtitle = styled.h2`
  font-size: 18px;
  font-weight: normal;
  padding-left: 12px;
  text-align: left;
`;

const Divider = styled.hr`
  height: 2px;
  border-top: 1px solid #0183d5;
  width: 100%;
  /* margin: -15px 0 -5px; */
  padding: 0 24px;
`;

const STATE = {
  //buyer: '',
  rdw_company_number: '',
  companyName: '',
  mileage: '',
  mileageUnit: 'K',
  regPlate: '',
  meldcode: '',
  vehicleId: null,
  noCounter: false,
  useIllogical: true,
};

let todaydate = new Date().toISOString();

/* eslint-disable react/prefer-stateless-function */
class ORBModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    const { item } = this.props;

    if (!!item?.id) {
      this.setState({
        vehicleId: item.id,
        meldcode: item?.vin?.slice(-4) ?? this.getProperty(item, 'vin')?.slice(-4),
        mileage: item?.mileage ?? this.getProperty(item, 'mileage'),
        regPlate: item?.regplate ?? this.getProperty(item, 'regplate'),
      });

      if (this.getProperty(item, 'invoice_outgoing_company_id')) {
        this.props.fetchCompany(this.getProperty(item, 'invoice_outgoing_company_id'), result => {
          const rdw = (result?.properties?.find(p => p?.name?.name === 'RDW_number')
         || result?.properties?.find(p => p?.name?.name === 'rdw_number'))?.value
         ?? '';
          this.setState({ company: result, rdw_company_number: rdw });
        });
      } else {
        let invoiceId;
        if (!item.outgoing_invoice) {
          this.props.fetchVehicleById(item.id, result => {
            invoiceId = this.getProperty(result, 'outgoing_invoice');
          });
        } else {
          invoiceId = item.outgoing_invoice;
        }
        if (!this.state.company && !!invoiceId) {
          this.props.fetchInvoice(invoiceId, result => {
            const { outgoingCompany } = result;
            this.setState({
              company: outgoingCompany,
              rdw_company_number: outgoingCompany?.properties?.find(p => p?.name?.name === 'RDW_number')?.value,
            });
          });
        }
      }
    } else {
      this.setState({
        mileage: item.kilometerstand ?? '',
        regPlate: item?.kenteken ?? '',
      });
      if (this.props.item?.regplate || this.props.item?.kenteken) {
        this.props.fetchVehicle(this.props.item?.regplate ?? this.props.item?.kenteken, result => {
          const vehicle = result?.items[0];
          const meldcode = this.getProperty(vehicle, 'vin')?.slice(-4);
          const mileage = this.getProperty(vehicle, 'mileage');
          this.setState({ vehicleId: vehicle?.id || this.props.item?.id, meldcode, mileage });
        });
      }
    }
  }

  getProperty = (vehicle, propName) =>
    vehicle?.properties?.propertyName
      ? vehicle?.properties?.find(p => p?.propertyName?.name === propName)?.propertyValue?.value
      : vehicle?.properties?.find(p => p?.propertyValue?.vehiclePropertyName?.name === propName)?.propertyValue?.value;

  reset() {
    this.setState({ ...STATE });
  }

  close = () => {
    this.props.onClose();
  };

  onNoCounterChange = () => {
    this.setState(state => ({ noCounter: !state.noCounter }));
  };

  handleIllogical = () => {
    this.setState(state => ({ useIllogical: !state.useIllogical }));
  };

  selectCompany = e => {
    this.setState({ companyName: e.value });
  };

  handleRDWChange = e => {
    this.setState({ rdw_company_number: e.target.value });
  };

  // onMeldcode = e => {
  //   this.setState({ meldcode: e.target.value });
  // };
  //
  // onRegPlate = e => {
  //   this.setState({ regPlate: e.target.value });
  // };

  onMileage = e => {
    this.setState({ mileage: e.target.value });
  };

  confirmVehicle = (isCalled = false) => {
    const requestData = {
      //mileage_report: !!this.state.noCounter,
      vehicleId: this.state.vehicleId,
      mileage: `${this.state.mileage}`,
      mileage_unit: this.state.mileageUnit ?? 'K',
      reg_plate: this.state.regPlate,
      status_code_mileage: '',
      //reg_plate_card: false,
      technical_claim_handling: this.state.useIllogical ? 'A' : 'B',
      // additional data
      //companyName: this.state.company.name,
      rdw_company_number: this.state.rdw_company_number,
      //buyer: this.state.buyer,
      meldcode: this.state.meldcode,
      // ORB_staged: 1,
      // sales_release_called: isCalled ? 1 : 0,
    };

    this.setState({ loading: true });

    this.props.confirm(requestData, result => {
      this.setState({ ...STATE, result, loading: false });
    });
  };

  handleSelectCompany = company => {
    this.setState({ company, rdw_company_number: company?.RDW_number ?? '' });
  };

  updateMileage = () => {
    if (!!this.state.vehicleId) {
      this.props.setVehicleProperty(this.state.vehicleId, 'mileage', this.state.mileage);
    }
  };

  sendTDN = () => {
    if (!!this.state.vehicleId) {
      this.props.setVehicleProperty(this.state.vehicleId, 'orb_staged', 1);
      this.props.setVehicleProperty(this.state.vehicleId, 'orb_staged_with_TDN', 1);
      this.props.setVehicleProperty(this.state.vehicleId, 'sales_release_date', todaydate);
    }
    this.props.onClose();
  };

  exportSalesRelease = () => {
    if (!!this.state.vehicleId) {
      this.props.setVehicleProperty(this.state.vehicleId, 'sales_release_export', 1);
      this.props.setVehicleProperty(this.state.vehicleId, 'sales_release_export_date', todaydate);
    }
    this.props.onClose();
  };

  exportDeleteFromBoard = () => {
    if (!!this.state.vehicleId) {
      this.props.setVehicleProperty(this.state.vehicleId, 'sales_release_delete', 1);
      this.props.setVehicleProperty(this.state.vehicleId, 'sales_release_delete_date', todaydate);
    }
    this.props.onClose();
  };

  updateRDWnumber = () => {
    if (!!this.state.company) {
      this.props.setCompanyProperty(this.state.company?.id, 'RDW_number', this.state.rdw_company_number);
    }
  };

  render() {
    const { item } = this.props;
    return (
      <ModalComponent onClose={this.close.bind(this)} title="ORB-B2B Outgoing" wider>
        {this.state.result?.result === false ? (
          this.renderError()
        ) : this.state.result ? (
          this.renderDone()
        ) : (
          <form>
            <div>
              <label className="form-label">{this.lbl('invoice.generating.buyer')}</label>
              {!!this.props.loadInvoice ? (
                <Loader />
              ) : (
                <div className="mb-2">
                  <div className="mb-2">
                    <CompanyLabel company={this.state.company} />
                  </div>

                  <CompanySelection
                    onSelect={company => {
                      this.handleSelectCompany(company);
                    }}
                  />
                </div>
              )}

              <label className="form-label">RDW number buyer</label>
              <div className="d-flex gap-2 mb-2 align-items-center">
                <input
                  className="form-control"
                  key="rdw_buyer"
                  value={this.state.rdw_company_number}
                  onChange={this.handleRDWChange}
                />
                <div className={styles.buttonContainerRDW}>
                  <ButtonComponent size={'btn-sm'} style={'ButtonSoftPrimary'} onClick={this.updateRDWnumber}>
                    {this.lbl('invoice.details.updateBtn')}
                  </ButtonComponent>
                </div>
              </div>

              <Subtitle>Add vehicle</Subtitle>
              <Divider />

              <label className="form-label">License Plate</label>
              <div className="mb-2">
                <input
                  className="form-control"
                  key="licenseplate"
                  value={this.state.regPlate ?? item.kenteken ?? ''}
                  onChange={this.onRegPlate}
                  disabled
                />
              </div>

              <label className="form-label">Brand</label>
              <span>{item?.brand_name ?? item.merk ?? '-'}</span>

              <label className="form-label">Model</label>
              <span>{item?.model_name ?? item.model ?? '-'}</span>

              <label className="form-label">Meldcode</label>
              <div className="mb-2">
                <input
                  className="form-control"
                  key="meldcode"
                  value={this.state.meldcode}
                  onChange={this.onMeldcode}
                  disabled
                />
              </div>

              <label className="form-label">Counter reading</label>
              <div className={styles.inputContainer}>
                <input className="form-control" key="couter_reading" value={this.state.mileage} onChange={this.onMileage} />
                <div className={styles.buttonContainer}>
                  <ButtonComponent size={'btn-sm'} style={'ButtonSoftPrimary'} onClick={this.updateMileage}>
                    {this.lbl('invoice.details.updateBtn')}
                  </ButtonComponent>
                </div>

                <div className={styles.buttonContainer}>
                  <CheckboxComponent label={'No counter'} onChange={this.onNoCounterChange} checked={this.state.noCounter} />
                </div>
              </div>

              <div className="mt-2 mb-2">
                <CheckboxComponent
                  label={'Als is aangevinkt gaat hij NIET door bij een onlogische tellerstand of een WOK-melding'}
                  checked={this.state.useIllogical}
                  onChange={this.handleIllogical}
                />
              </div>
            </div>

            <div>
              {this.props.work || this.state.loading ? (
                <Loader small />
              ) : (
                <div className={styles.buttonGrid}>
                  <ButtonComponent style={'ButtonSoftDelete'} onClick={this.close}>
                    {this.lbl('cancel')}
                  </ButtonComponent>
                  <ButtonComponent style={'ButtonSoftDelete'} onClick={this.exportDeleteFromBoard}>
                    {this.lbl('label.delete')}
                  </ButtonComponent>
                  <ButtonComponent style={'ButtonSoftEdit'} onClick={this.sendTDN}>
                    {this.lbl('orb.modal.tdn')}
                  </ButtonComponent>
                  <ButtonComponent style={'ButtonSoftEdit'} onClick={this.exportSalesRelease}>
                    {this.lbl('label.export')}
                  </ButtonComponent>
                  {/* <Button onClick={() => this.confirmVehicle(true)}>{this.lbl('orb.modal.called')}</Button> */}
                  <ButtonComponent style={'ButtonSoftEdit'} onClick={this.confirmVehicle}>
                    {this.lbl('confirm')}
                  </ButtonComponent>
                </div>
              )}
            </div>
          </form>
        )}
      </ModalComponent>
    );
  }

  renderError() {
    return (
      <>
        <Times />
        {this.state.result?.data?.message ?? 'Error'}
        <ModalControls>
          <Button onClick={this.close.bind(this)}>{this.lbl('close')}</Button>
        </ModalControls>
      </>
    );
  }

  renderDone() {
    return (
      <>
        <Check /> {this.lbl('complete')}
        <ModalControls>
          <Button onClick={this.close.bind(this)}>{this.lbl('close')}</Button>
        </ModalControls>
      </>
    );
  }
}

ORBModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLES, ORB_TRANSFER_OUT),
    loadInvoice: selectWork(REQUEST_INVOICE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchVehicle(regplate, callback) {
      dispatch(vehicleSearch(regplate, callback));
    },
    fetchVehicleById(vehicleId, callback) {
      dispatch(fetchVehicle(vehicleId, callback));
    },
    confirm: (carInfo, callback) => {
      dispatch(orbTransferOut(carInfo, callback));
    },
    fetchInvoice: (invoiceId, callback) => {
      dispatch(fetchInvoice(invoiceId, callback));
    },
    fetchCompany(companyId, callback) {
      dispatch(fetchCompany(companyId, callback));
    },
    setVehicleProperty(vehicleId, name, value, callback) {
      dispatch(setVehicleProperty(vehicleId, name, value, callback));
    },
    setCompanyProperty(companyId, name, value, callback) {
      dispatch(setCompanyProperty(companyId, name, value, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ORBModal = compose(withRouter, withConnect)(ORBModalComp);
